import styles from './WorkspacePostingCount.module.css'

export interface WorkspacePostingCountProps {
  count: number
}

export function WorkspacePostingCount({ count }: WorkspacePostingCountProps) {
  return (
    <div className={styles.root}>
      All postings
      <span className={styles.postingCount}>({count})</span>
    </div>
  )
}
